import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {type} from "ramda";
import { dispatchEvent } from 'fg-frontend/src/lib/dom';
import {getWebComponentInstance} from "fg-frontend/src/webComponents/decorate";
import {execute} from "fg-frontend/src/partialUpdate/partialUpdate";

const fragments = {
	PRODUCT_NOMINAL_CARD: '[data-fragment="OrderNominal.productNominalCard"]',
	PRODUCT_NOMINAL_CARD_INPUT: '[data-fragment="OrderNominal.productNominalCard"] input',
	PRODUCT_NOMINAL_BRANCH_ROW: 'tbody tr[data-total-sum]',
	PRODUCT_NOMINAL_TOTAL_SUM: '[data-fragment="OrderNominal.productNominalTotalSum"]',
};

class CardOrderNominal extends WebComponent {
	constructor(props) {
		super(props);
		const {
		} = props;
	}

	didMount() {
		const {
			commitClass,
		} = this.props;

		this.commitClass = commitClass;

		const universalPreloaderComponentElement = document.getElementById('universalPreloader');
		this.universalPreloaderComponent = getWebComponentInstance(universalPreloaderComponentElement);

		/* Objednávka karet */
		this.orderNominalItemCardOrderElements = this.element.querySelectorAll(fragments.PRODUCT_NOMINAL_CARD_INPUT);
		if(this.orderNominalItemCardOrderElements.length > 0) {
			this.on('change', fragments.PRODUCT_NOMINAL_CARD_INPUT, this.initOrderNominalItemCardOrder);
			for(let i = 0; i < this.orderNominalItemCardOrderElements.length; i++) {
				this.handleChangeCardStatus(this.orderNominalItemCardOrderElements[i]);
			}
		}
	}

	initOrderNominalItemCardOrder = (e) => {
		this.addCommitClass(e.target);
		this.handleChangeCardStatus(e.target);
		this.commitChanges();
	};

	handleChangeCardStatus = (e) => {
		let orderNominalItemCardOrder = e.parentElement.parentElement.querySelector('.order-nominal__item--card-order');
		if(orderNominalItemCardOrder) {
			if(e.checked) {
				orderNominalItemCardOrder.classList.remove('order-nominal__item--hide');
			} else {
				orderNominalItemCardOrder.classList.add('order-nominal__item--hide');
			}
		}
	};

	addCommitClass = (e) => {
		e.parentElement.closest('tr').classList.add(this.commitClass);
	};

	getCsrfToken = () => {
		return document.querySelector('form[id^=orderRecord] input[name=csrf]').value;
	};

	getFormId = () => {
		return document.querySelector('form[id^=orderRecord] input[name=formId]').value;
	};

	filterRows = (filterFullName, filterEmployeeNumber, branchId) => {
		let i;
		let productNominalRows = this.element.querySelectorAll('tbody tr[data-branch-id="'+branchId+'"]');
		for(i = 0; i < productNominalRows.length;i++) {
			if(productNominalRows[i].getAttribute('data-full-name').includes(filterFullName.toLowerCase())) {
				productNominalRows[i].style.display = 'table';
			} else {
				productNominalRows[i].style.display = 'none';
			}
		}
		productNominalRows = this.element.querySelectorAll('tbody tr:not([style*="display: none"])[data-branch-id="'+branchId+'"]');
		for(i = 0; i < productNominalRows.length;i++) {
			if (productNominalRows[i].getAttribute('data-employee-number').includes(filterEmployeeNumber.toLowerCase())) {
				productNominalRows[i].style.display = 'table';
			} else {
				productNominalRows[i].style.display = 'none';
			}
		}
	};

	commitChanges = () => {
		let toCommitElements = this.element.querySelectorAll('tbody tr.toCommit');
		let i, dataJSON = [];
		let _self = this;
		if(toCommitElements.length > 0) {
			for(i = 0; i <toCommitElements.length; i++){
				let inputCardElement = toCommitElements[i].querySelector('input[type="checkbox"]'); // Karta
				let inputCardElementValue = 0;
				if(inputCardElement) {
					if(inputCardElement.checked) {
						inputCardElementValue = 1;
					} else {
						inputCardElementValue = 0;
					}
				}
				let dataTableTr = inputCardElement.closest('tr');
				dataJSON.push({
					card: inputCardElementValue,
					personId: dataTableTr.getAttribute('data-person-id'),
					branchId: inputCardElement.getAttribute('data-branch-id'),
				});
			}
			this.universalPreloaderComponent.handleOn(10);

			let commitUrl = window.location.pathname + '?formId=' + this.getFormId() + '&csrf=' + this.getCsrfToken() + '&eventName.storeData:orderRecord=';
			let xmlHttpReq = new XMLHttpRequest();
			xmlHttpReq.open('POST', commitUrl, true);
			xmlHttpReq.setRequestHeader("Content-Type", "application/json");
			xmlHttpReq.onreadystatechange = function () {
				if (xmlHttpReq.readyState === 4) {
					if (xmlHttpReq.status === 200) {
						let data = JSON.parse(xmlHttpReq.responseText);
						console.log("onreadystatechange to server - " + data.ok);
						if (data.ok) {
							for(i = 0; i <toCommitElements.length; i++){
								toCommitElements[i].classList.remove(_self.commitClass);
							}
							execute({
								url: _self.href,
								target: 'productNominalTotalSum',
							});
						}
					}

				}
				_self.universalPreloaderComponent.handleOff(10);
			};
			xmlHttpReq.send(JSON.stringify(dataJSON));
		}

	};


}

CardOrderNominal.defaultProps = {
	commitClass: 'toCommit',
};

export default CardOrderNominal;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Orders/CardOrderNominal.js